

import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";

import { MapperUtente } from "./mapper-utente";
import { VisibilitaAttoDTO } from "../dto/visibilita-attoDTO";
import { VisibilitaAttoVO } from "../vo/visibilita-attoVO";




@Injectable({
    providedIn: "root"
})
export class MapperVisibilitaAtto implements MapperInterface<VisibilitaAttoDTO, VisibilitaAttoVO> {
    constructor(
        private mapperUtente: MapperUtente
    ) {

    }
    convertVoToDto(vo: VisibilitaAttoVO): VisibilitaAttoDTO {
        if (vo != null) {
            const dto = new VisibilitaAttoDTO();
            // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
            dto.dataFineVisibilita = vo.dataFineVisibilita;
            dto.dataInizioVisibilita = vo.dataInizioVisibilita;
            dto.operatore = this.mapperUtente.convertVoToDto(vo.operatore);
            dto.utente = this.mapperUtente.convertVoToDto(vo.utente);
            return dto;
        } else {
            return null;
        }
    }

    convertDtoToVo(dto: VisibilitaAttoDTO): VisibilitaAttoVO {
        if (dto != null) {
            const vo = new VisibilitaAttoVO();
            // TODO fare mapper questa riga funge solo se DTO e VO sono identici
            // vo = JSON.parse(JSON.stringify(dto));
            vo.dataFineVisibilita = dto.dataFineVisibilita;
            vo.dataInizioVisibilita = dto.dataInizioVisibilita;
            vo.operatore = this.mapperUtente.convertDtoToVo(dto.operatore);
            vo.utente = this.mapperUtente.convertDtoToVo(dto.utente);
            return vo;
        } else {
            return null;
        }
    }

    convertListVoToDto(voList: VisibilitaAttoVO[]): VisibilitaAttoDTO[] {
        if (voList != null) {
            return voList.map(vo => this.convertVoToDto(vo));
        } else {
            return null;
        }
    }

    convertListDtoToVo(dtoList: VisibilitaAttoDTO[]): VisibilitaAttoVO[] {
        if (dtoList != null) {
            return dtoList.map(dto => this.convertDtoToVo(dto));
        } else {
            return null;
        }
    }
}
